import styled from "styled-components";

export const HitArea = styled.button`
  width: 100%;
  border: none;
  padding: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  background: #f6f6f6;
  border-radius: 8px;
  border: 1px solid #d8d8d8;
  padding-left: 12px;
  padding-right: 31px;
  padding-top: 14px;
  padding-bottom: 15px;
`;

export const DateSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2px;
`;

export const DateMonthText = styled.div`
  font-size: 16px;
  font-weight: 900;
  color: #000000;
`;

export const DayYearText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
  margin-top: 2px;
`;

export const DurationWrap = styled.div`
  position: relative;
`;

export const Diagonal = styled.div`
  position: absolute;
  width: 45px;
  height: 1px;
  background: #d1d5db;
  transform: rotate(-45deg);
  top: 8px;
  left: -1px;
`;

export const DurationBadge = styled.div`
  border: 1px solid #e7e7e7;
  border-radius: 24px;
  padding: 2px 5px;
  background: #fff;
  position: relative;
`;

export const DurationText = styled.div`
  font-size: 9px;
  color: #757575;
  text-align: center;
`;

